<template>
  <div class="wagenbuchEreginis">
    <form-builder
      v-if="displayedForm"
      :displayedForm="displayedForm"
      :formModel="formModel"
      :mediasModel="mediasModel"
      :dataLoaded="dataLoaded"
      :disableSendButton="disableSendButton"
      @formUpdated="formUpdated"
      @resetForm="resetForm"
      @sendForm="sendForm"
    />
    <!--<div v-else-if="isStaticForm" v-html="staticContent"></div>-->
    <div v-else-if="!loading">No Form found for {{ this.$route.query.name }}</div>
    <div v-else>Loading...</div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import common from '@/mixins/common';
import configMixin from '../../mixins/configMixin';
import config from '@/common/config';
import axios from 'axios';
import MODULE_ID from './moduleId';
import dateUtils from '@/common/dateUtils';
import api from '@/api/formsApi';
import { preprocessImage } from '@/common/mediaUtils';
import FormBuilder from '../forms/FormBuilder';
import vehicleMixin from "@/mixins/vehicleMixin";

export default {
  name: 'WagenbuchEreignis',
  mixins: [common, configMixin,vehicleMixin],
  components: { FormBuilder },
  data() {
    return {
      config: config,
      loading: true,
      formModel: {},
      mediasModel: [],
      formReports: {},
      disableSendButton: false,
      staticContent: '',
    };
  },
  computed: {
    ...mapState('wagenbuch', ['ereignisse', 'dataLoaded']),
    ...mapState('forms', ['autofill']),
    formId() {
      return this.displayedForm ? this.displayedForm.id : undefined;
    },
    isStaticForm() {
      return this.displayedForm ? this.displayedForm.static && this.displayedForm.static === 1 : false;
    },
    displayedForm() {
      const ereignis = this.ereignisse.find((item) => item.name === this.$route.query.name);
      return { ...ereignis, allowEdit: 0, allowMultipleSubmit: 1, backgroundColor: '#FFFFFF' };
    },
    fzName(){
      return this.$route.params.fzName?this.$route.params.fzName:this.$route.query.fzName;
    },
    fzId(){
      return Number(this.$route.params.fzId?this.$route.params.fzId:this.$route.query.fzId);
    },
  },
  async created() {
    // used for static forms, to be implemented to get files from /module/wagenbuch/static
    // currently only watching for
    /*
    await this.$store.dispatch('sync/invalidateModuleCacheAndSync', { moduleId: MODULE_ID }, { root: true });
    if (this.isStaticForm) {
      await axios
        .get(`${this.config.apiUrl}/medias/wagenbuch/static/${this.displayedForm.file}/${this.displayedForm.checksum}`)
        .then((res) => {
          this.staticContent = res.data;
          // Overwrite onsubmit functionality of generate form
          document.getElementsByTagName('form')[0].onsubmit = this.sendStaticForm;
        })
        .catch((e) => {
          console.error(e);
          this.staticContent = '';
        });
    }
    */

    this.setInitialFormValues();
    this.setInitialMediaValues();

    this.loading = false;
  },
  methods: {
    formUpdated(key, value) {
      this.formModel = { ...this.formModel, [key]: value };
    },
    resetForm() {
      this.formModel = {};
      this.mediasModel = [];
      this.setInitialFormValues();
      this.setInitialMediaValues();
    },
    setInitialFormValues() {
      if (this.displayedForm && this.displayedForm.formbuilderdata && this.displayedForm.formbuilderdata.fields) {
        if (Array.isArray(this.displayedForm.formbuilderdata.fields)) {
          this.displayedForm.formbuilderdata.fields.forEach((field) => {
            if (field.cid && field.field_type && field.field_options) {
              const reportValue = this.getFormReportValue(field.cid);
              switch (field.field_type) {
                case 'checkboxes': {
                  const initialValue = {};
                  field.field_options.options.forEach((checkbox) => {
                    initialValue[checkbox.label] = checkbox.checked;
                  });
                  if (field.field_options.include_other_option) {
                    initialValue['Anderes'] = false;
                  }
                  if (reportValue) {
                    for (const label in initialValue) {
                      initialValue[label] = label === reportValue;
                    }
                  }
                  this.formModel[field.cid] = initialValue;
                  break;
                }
                case 'radio': {
                  if (reportValue) {
                    this.formModel[field.cid] = reportValue;
                  } else {
                    field.field_options.options.forEach((item) => {
                      if (item.checked) {
                        this.formModel[field.cid] = item.label;
                      }
                    });
                  }
                  break;
                }
                case 'table':
                  this.formModel[field.cid] = [];
                  if (Array.isArray(reportValue)) {
                    const labels = field.field_options.columns.map((c) => c.label);
                    const chunks = [];
                    while (reportValue.length > 0) {
                      chunks.push(reportValue.splice(0, field.field_options.columns.length));
                    }
                    for (let chunk of chunks) {
                      let colData = {};
                      chunk.forEach((val, idx) => {
                        colData[labels[idx]] = val;
                      });
                      this.formModel[field.cid].push(colData);
                    }
                  }
                  break;
                case 'dropdown': {
                  const defaultOption = field.field_options.options.find((o) => o.checked === true);
                  this.formModel[field.cid] = defaultOption === undefined ? undefined : defaultOption.label;
                  break;
                }
                case 'dynamicDropdown': {
                  const defaultOption = field.field_options.options.find((o) => o.checked === true);
                  this.formModel[field.cid] = defaultOption === undefined ? undefined : defaultOption.label;
                  break;
                }
                case 'text':
                  if (reportValue) {
                    this.formModel[field.cid] = reportValue;
                  } else if (field.field_options.auto_fill) {
                    this.formModel[field.cid] = this.autofill[field.field_options.auto_fill];
                  } else {
                    this.formModel[field.cid] = '';
                  }
                  break;
                case 'date':
                  if (reportValue) {
                    this.formModel[field.cid] = reportValue;
                  } else if (field.field_options.current_time) {
                    this.formModel[field.cid] = new Date().toISOString().substring(0, 10);
                  } else {
                    this.formModel[field.cid] = '';
                  }
                  break;
                case 'time': {
                  if (reportValue) {
                    this.formModel[field.cid] = reportValue;
                  } else if (field.field_options.current_time) {
                    this.formModel[field.cid] = dateUtils.formatTimeHHmm(new Date());
                  } else {
                    this.formModel[field.cid] = '';
                  }
                  break;
                }
                case 'address':
                  this.formModel[field.cid + '_Ort'] = this.getFormReportValue(field.cid + '_Ort');
                  this.formModel[field.cid + '_PLZ'] = this.getFormReportValue(field.cid + '_PLZ');
                  this.formModel[field.cid + '_Strasse'] = this.getFormReportValue(field.cid + '_Strasse');
                  break;
                case 'range':
                  this.formModel[field.cid + '_from'] = this.getFormReportValue(field.cid + '_from');
                  this.formModel[field.cid + '_to'] = this.getFormReportValue(field.cid + '_to');
                  this.formModel[field.cid] = reportValue;
                  break;
                default:
                  if (!['section_break', 'static_link', 'image'].includes(field.field_type)) {
                    this.formModel[field.cid] = reportValue;
                  }
              }
            }
          });
        }
      }
    },
    getFormReportValue(fieldCid) {
      if (this.formId && this.formReports[this.formId]) {
        if (this.formReports[this.formId].data && Array.isArray(this.formReports[this.formId].data)) {
          const reportValue = this.formReports[this.formId].data.filter((item) => item.name === fieldCid);
          if (reportValue.length == 1) {
            return reportValue[0].value;
          }
          if (reportValue.length > 1) {
            const reportValues = [];
            reportValue.forEach((item) => {
              reportValues.push(item.value);
            });
            return reportValues;
          }
        }
      }
      return '';
    },
    setInitialMediaValues() {
      // set report values
      if (
        this.displayedForm &&
        this.displayedForm.allowEdit &&
        this.displayedForm.allowEdit === 0 &&
        this.displayedForm.allowMultipleSubmit &&
        this.displayedForm.allowMultipleSubmit === 0
      ) {
        if (this.formReports[this.formId] && this.formReports[this.formId].medias) {
          this.formReports[this.formId].medias.forEach(async (media) => {
            const r = await api.getReportImage(media.filename, media.checksum);
            const base64File = await preprocessImage(r.data);
            this.mediasModel.push({
              field: media.cid,
              base64File,
            });
          });
        }
      }
    },
    async sendForm(data) {
      const moduleConfig = this.getModuleConfig('Wagenbuch', this.$route.params.instance);

      this.disableSendButton = true;

      await this.$store.dispatch('wagenbuch/sendEreignis', {
        instance: this.$route.params.instance,
        module: moduleConfig.title,
        formData: {
          json: JSON.stringify(data?.formData),
          ereignisId: this.formId,
          fzName: this.vehicle.fzName,
        },
        medias: data?.mediaData,
      });

      this.disableSendButton = false;
      this.resetForm();

      this.$router.push({name:'wagenbuch',params:{fzId:this.vehicle.id},query:{tab:'ereignis'}});

    },

    async sendStaticForm(event) {
      const moduleConfig = this.getModuleConfig('Wagenbuch', this.$route.params.instance);

      event.preventDefault(); //Don't change URL on submit
      const formData = [];

      //Read formadata
      Array.from(event.target.elements).forEach((e) => {
        if (!e.disabled && !e.hidden && e.value !== '' && e.value !== undefined) {
          formData.push({ name: e.name, value: e.value });
        }
      });
      //Save formdata
      await this.$store.dispatch('wagenbuch/sendEreignis', {
        instance: this.$route.params.instance,
        module: moduleConfig.title,
        formData: {
          json: JSON.stringify(formData),
          ereignisId: this.ereignis.id,
          fzName: this.fzName,
        },
      });
      this.$router.push('/wagenbuch?tab=ereignis');
    },
  },
};
</script>

<style>
.wagenbuchEreginis .form-actions {
  bottom: 52px !important;
}
</style>
